export enum SortbyFilter {
    PLACED = 1,
    DELIVER = 2
}

export enum SortByType {
    Drafts = 'drafts',
    Leads = 'leads'
}